import { logError, logEvent } from '../error';
export const fetchData = async (dataUrl) => {
    try {
        const res = await fetch(dataUrl);
        if (!res.ok) {
            const metadata = { status: res.status, dataUrl };
            res.status === 404
                ? logEvent({ objectName: 'fileFetch', actionName: 'notFound', metadata })
                : logEvent({ objectName: 'fileFetch', actionName: 'requestFailed', metadata });
            return null;
        }
        return await res.json();
    }
    catch (error) {
        logError({ error });
        return null;
    }
};
